import styled from 'styled-components';

export const Wrapper = styled.div`
    height: 100%;
`;

export const SearchWrapper = styled.div`
    padding: 1rem 2rem 0rem 0rem;
    .content {
        color: #000000;
    }
    .fields-container {
        display: flex;
        margin-top: 1rem;
    }
    .table-container {
        margin-top: 2.5rem;
        .title {
            color: #000;
            font-weight: bold;
            margin-bottom: 1rem;
        }
        .table-content {
            color: #000;
        }
        .ant-table-thead > tr > th {
            padding: 8px 16px;
            background: #F2F2F2;
            border-top: 1px solid #9B9B9B;
        }
        .title-wrapper {
            display: flex;
            justify-content: space-between;
        }
        .download-btn {
            width: 100px;
            border-color: #0000FF;
        }
        .ant-table-row-expand-icon {
            color: #2930ff;
            border-color: #2930ff;
        }
        .link-wrapper {
            text-decoration: none;
        }
        .id-wrapper {
            background-color: #0000FF;
            width: 35px;
            height: 25px;
            padding: 4px;
            font-size: 12px;
            color: #fff;
        }
    }   
`
export const AllUserWrapper = styled.div`
    .container {
        padding: 1rem 0rem 0rem 0rem;
        .title {
            font-weight: bold;
            color: #000;
        }
        .field-wrapper {
            display: flex;
            margin-top: 5px; 
        }
        .flex-content {
            display: flex;
        }
        .details-menu {
            color: #000;
            margin-top: 10px;
        }
        .full-width {
            flex: 1;
        }
        .ant-select {
            width: 150px;
        }
        .ant-select-selection  {
            border-radius: 0px;
        }
        .ant-input-search {
            width: 200px;
        }
        .ant-input {
            border-radius: 0px;
        }
    }
`;
